import React, { useEffect } from 'react'
import "./HomeContainer.css"
import { useDispatch, useSelector } from 'react-redux';
import { fetchUsers } from '../../hooks/Users';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { fetchProducts } from '../../hooks/Products';
import { fetchOrders } from '../../hooks/Orders';
function HomeContainer({orders}) {
  const dispatch = useDispatch();
        const {list:users } = useSelector((state) => state.users);
        const {list:Products } = useSelector((state) => state.products);
  const userinfo = useSelector((state) => state);


  useEffect(() => {
    dispatch(fetchUsers());
    dispatch(fetchProducts());


  }, [dispatch]);
console.log(orders);

  return (
    <div className='mt-4'>
      <Container>
        <Row>
          <Col md={4}>
            <Link to="/dashboard/users">
              <div className='d-flex justify-content-between bg-white  shadow py-2 px-4 rounded'>
                <div>
                  <p className='fw-bold fs-5 text-black'>All Users</p>
                  <p className='fw-semibold fs-5 text-black'>{users.length}</p>
                </div>
              </div>
            </Link>
          </Col>
          <Col md={4}>
          <Link to="/dashboard/products">
<div className='d-flex justify-content-between bg-white  shadow py-2 px-4 rounded'>
  <div>
    <p className='fw-bold fs-5 text-black'>All Products</p>
    <p  className='fw-semibold fs-5 text-black'>{Products?.length}</p>
  </div>
</div>
</Link>
          </Col>
          <Col md={4}>
          <Link to="/dashboard/orders">
<div className='d-flex justify-content-between bg-white  shadow py-2 px-4 rounded'>
  <div>
    <p className='fw-bold fs-5 text-black'>All orders</p>
    <p  className='fw-semibold fs-5 text-black'>{orders.length}</p>
  </div>
</div>
</Link>          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default HomeContainer